// extracted by mini-css-extract-plugin
export default {"root":"YrK9g08C_b7IuDNO67P1","flag":"MlFU3P1_srB1yj4kAx5q"};